// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"319":"mobs-habblet","641":"badges-habblet"}[chunkId] + "." + {"319":"a7b1cafe","641":"a7b1cafe"}[chunkId] + ".css";
};